import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import UserArchiveTable from './userArchiveTable/UserArchiveTable';
import { getArchivedUsers } from '../../../redux/userManagement/actions';
import { Grid, Button } from '@mui/material';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import AddUserModal from '../UserListSection/addUserModal/AddUserModal';
import { openModal } from '../../../redux/modals/action';
import EditAccessibilityModal from '../UserListSection/editAccessibilityModal/EditAccessibilityModal';
import styles from './UserArchiveSection.module.scss';
import UserDetailsCard from '../UserListSection/userDetailsCard/UserDetailsCard';
import { getClickedUser } from '../../../redux/userManagement/actions';
import {
	setConfirmation,
	closeConfirmation,
} from '../../../redux/confirmations/actions';
import ConfirmationComponent from '../../confirmation/ConfirmationComponent';
import { deleteUser } from '../../../api/UserManagement/deleteUser.api';
import { setUserUnarchived } from '../../../api/UserManagement/setUserArchive.api';

const UserArchiveSection = (props) => {
	const {
		getArchivedUsers,
		setSection,
		modals,
		openModal,
		getClickedUser,
		setConfirmation,
		closeConfirmation,
		confirmation,
	} = props;
	const [userSelected, setUserSelected] = useState();
	const [projectToEdit, setProjectToEdit] = useState();
	const [deleteUsersId, setDeleteUsersId] = useState([]);
	const [unarchiveUsersId, setUnarchiveUsersId] = useState([]);

	const deleteUsersButtonList = [
		{
			name: 'Discard',
			action: () => {
				handleCloseDeleteUsersConfirmation();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Yes',
			action: () => {
				handleDeleteUsersConfirmation();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--error)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
	];

	const unarchiveUsersButtonList = [
		{
			name: 'Discard',
			action: () => {
				handleCloseUnarchiveUsersConfirmation();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Yes',
			action: () => {
				handleUnarchiveUsersConfirmation();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--error)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
	];

	useEffect(() => {
		getArchivedUsers();
	}, []);

	const handleEditAccessibility = (id) => {
		openModal('editAccessibility');
		setProjectToEdit(id);
	};

	const handleBackToUserManagement = () => {
		setSection('user list');
		getClickedUser('');
	};

	const handleOpenDeleteUsersConfirmation = async (id) => {
		await setConfirmation('deleteUsers');
		setDeleteUsersId(id);
	};

	const handleCloseDeleteUsersConfirmation = () => {
		closeConfirmation('deleteUsers');
	};

	const handleDeleteUsersConfirmation = async () => {
		for (let userId of deleteUsersId) {
			if (userId) {
				await deleteUser(userId);
			}
		}
		closeConfirmation('deleteUsers');
	};

	const handleOpenUnarchiveUsersConfirmation = async (id) => {
		await setConfirmation('unarchiveUsers');
		setUnarchiveUsersId(id);
	};

	const handleCloseUnarchiveUsersConfirmation = () => {
		closeConfirmation('unarchiveUsers');
	};

	const handleUnarchiveUsersConfirmation = async () => {
		for (let userId of unarchiveUsersId) {
			if (userId) {
				await setUserUnarchived(userId);
			}
		}
		closeConfirmation('unarchiveUsers');
	};

	return (
		<div className={styles.user_archive_section}>
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Button
						className={styles.back_btn}
						startIcon={
							<ArrowBackIosIcon
								className={styles.back_btn_icon}
							/>
						}
						size='small'
						onClick={handleBackToUserManagement}
					>
						Back to User Management
					</Button>
				</Grid>
				<Grid item xs={8}>
					<UserArchiveTable
						setUserSelected={setUserSelected}
						openDeleteUsersConfirmation={
							handleOpenDeleteUsersConfirmation
						}
						openUnarchiveUsersConfirmation={
							handleOpenUnarchiveUsersConfirmation
						}
					/>
				</Grid>
				<Grid item xs={4}>
					<UserDetailsCard />
				</Grid>
			</Grid>
			<AddUserModal
				showModal={modals.addUserMgmt}
				userSelected={userSelected}
				handleEditAccessibility={handleEditAccessibility}
				openDeleteUsersConfirmation={handleOpenDeleteUsersConfirmation}
				openUnarchiveUsersConfirmation={
					handleOpenUnarchiveUsersConfirmation
				}
				isArchived={true}
			/>
			<EditAccessibilityModal
				show={modals.editAccessibility}
				projectToEdit={projectToEdit}
			/>
			<ConfirmationComponent
				open={confirmation?.deleteUsers}
				handleClose={handleCloseDeleteUsersConfirmation}
				title={confirmation['confirmationDetails']['title']}
				dialogContent={confirmation['confirmationDetails']['message']}
				buttonList={deleteUsersButtonList}
			/>
			<ConfirmationComponent
				open={confirmation?.unarchiveUsers}
				handleClose={handleCloseUnarchiveUsersConfirmation}
				title={confirmation['confirmationDetails']['title']}
				dialogContent={confirmation['confirmationDetails']['message']}
				buttonList={unarchiveUsersButtonList}
			/>
		</div>
	);
};

const mapStateToProps = (state) => ({
	modals: state.modals,
	confirmation: state.confirmation,
});

export default connect(mapStateToProps, {
	getArchivedUsers,
	openModal,
	getClickedUser,
	setConfirmation,
	closeConfirmation,
})(UserArchiveSection);
